import {Component, Prop, Vue, Watch} from '@/node_modules/nuxt-property-decorator';
import RoutingUtil from "@/classes/view/routing-util";
import APage from '@/classes/page/a-page';
import {appModule} from '@/store/app';
import {News} from "@/configs/news";

@Component({
	layout: 'teaser'
})
export default class Index extends APage {

	public title: string;

    ///////// 全ページ共通 ////////////////////////////////////////////
    public mypagetype: string = 'official-page';
	public mydivider: string = 'full';


    ///////// このページ ////////////////////////////////////////////
    public list: any = News;


    // ヘッダタグの構成要素
    public head() {
        return {
            title: 'ニュース｜THOUGHT ブランディングツール'
        }
    }

    ///////// 全ページ共通 ////////////////////////////////////////////
    public transition(to: any, from: any) {
		return RoutingUtil.transition(to, from);
	}

    public created(){

		///////// 全ページ共通 ////////////////////////////////////////////
		this.setPagetype( appModule, this.mypagetype, this.mydivider );


        ///////// このページ ////////////////////////////////////////////
    }

    ///////// Computed ////////////////////////////////////////////


	public get deviceSize(): any {
    	return appModule.deviceSize;
	}
}




